import MainLayout from "@/components/layout/admin/MainLayout.vue";
import flatPickr from 'vue-flatpickr-component';
import Select2Multiple from "v-select2-multiple-component";
import Loading from "vue-loading-overlay";
import 'flatpickr/dist/flatpickr.css';
import { 
    required,
    minValue
 } from "vuelidate/lib/validators";
import axios from "axios";
import store from '@/store'
import CONFIG from "@/assets/js/config.js";

export default {
    name: "DamageLossesCreate",
    components: {
        MainLayout,
        flatPickr,
        Select2Multiple,
        Loading
    },

    data() {
        return {
            damageLossesData: {
                library_member_id: null,
                book_id: 0,
                status: null,
                description: '',
                quantity: 0,
                type: null,
            },
            getAllBooks: [],
            isError: false,
            submitted: false,
            campusId: store.state.user.campus_master.campus_code,
            disabled: false,
            memberArr: null,
            bookArr: null,
            isLoading: false,
            noMemberMsg: '',
            noLibraryMemberMsg: '',
            noBookMsg: '',
            campus_id: this.$store.state.user.campus_id,
            bookTypes: CONFIG.BOOK_TYPE_VALUE,
            config: CONFIG,
        };
    },

    validations: {
        damageLossesData: {
            book_id: {
                required,
            },
            status: {
                required
            },
            description: {
                required,
            },
            quantity: {
                required,
                minValue: minValue(1),
            },
        },
    },

    computed: {
        isValidMember() {
            if(this.damageLossesData.library_member_id){
                if (!Array.isArray(this.memberArr) || this.memberArr.length === 0) return false;
                return this.memberArr.some(member =>
                    Number(member.id) === Number(this.damageLossesData.library_member_id)
                );
            }else{
                return true;
            }
        },
        isValidBook() {
            if (!Array.isArray(this.bookArr) || this.bookArr.length === 0) return false;
            return this.bookArr.some(book => 
                Number(book.id) === Number(this.damageLossesData.book_id)
            );
        },
        minRequired() {
            if (this.damageLossesData.type == this.bookTypes["Physical Book"] && this.damageLossesData.quantity <= 0) {
                return true;
            }
        },
        maxLimit() {
            if (this.damageLossesData.quantity > Number(this.getAllBooks[this.damageLossesData.book_id].remaining_quantity)) {
                return true;
            }
        },
        isCountableBook() {
            if (this.damageLossesData.book_id && !this.damageLossesData.book_id == 0 && this.damageLossesData.type == this.bookTypes["Physical Book"]) {
                return true;
            }
        }
    },

    methods: {
        getMember() {
            let $defaultSelectOption = [{
                'id': null,
                'text': 'Select Member'
            }];
            axios.get("/member/getList", {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                }
            })
                .then(res => {
                    if (res.data.data.length > 0) {
                        this.memberArr = $defaultSelectOption.concat(res.data.data);
                    } else {
                        this.memberArr = $defaultSelectOption;
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getBookList() {
            this.isLoading = true;
            const campusId = this.$store.state.user.campus_id;
            axios.get(`book/list`, {
                params: {
                        campusId: campusId
                    }
                })
                .then((res) => {
                    const filterEbook = res.data.data.filter(book => book.type != this.bookTypes['Ebook']);
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Book'
                    }];
                    
                    if (res.data && res.data.data && filterEbook.length) {
                        let bookOptions = filterEbook.map(book => {
                                return {
                                    id: book.id,
                                    text: book.title
                                };
                        });

                        [{type: 0, quantity: 0}].concat(filterEbook.forEach(book => this.getAllBooks[book.id] = book));
                        this.bookArr = $defaultSelectOption.concat(bookOptions);
                        this.noBookMsg = '';
                    } else {
                        this.bookArr = $defaultSelectOption;
                        this.noBookMsg = 'No Book for this campus.';
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else {
                        console.error("Error fetching book list:", error);
                    }
                    this.isLoading = false;
                });
        },

        validateForm() {
            this.errors = {};
            const integerValidator = (value) => Number.isInteger(Number(value));
        
            if (!integerValidator(this.damageLossesData.library_member_id)) {
                this.errors.library_member_id = 'Library Member must be an integer.';
            } else if (!this.isValidMember) {
                this.errors.library_member_id = 'Selected Library Member is not valid.';
            }

            if (!this.damageLossesData.book_id) {
                this.errors.book_id = 'Book is required.';
            } else if (!integerValidator(this.damageLossesData.book_id)) {
                this.errors.book_id = 'Book must be an integer.';
            } else if (!this.isValidBook) {
                this.errors.book_id = 'Selected Book is not valid.';
            }

            if (this.minRequired) {
                this.errors.book_id = 'Quantity must be at least one.';
            } else if (this.maxLimit) {
                this.errors.book_id = 'Quantity must be less than quantity of book.';
            }
            return this.errors;
        },

        create() {
          if (this.disabled) return;
            this.submitted = true;
            if (this.$v.$invalid || this.isError) {
                return;
            }

            if (Object.keys(this.validateForm()).length) {
                return;
            }
            
            this.disabled = true;
            axios.post('damageAndLoss/create', this.damageLossesData)
                .then(res => {
                    if (res.data.success == true) {
                        this.$notification.success("Damage and Losses Book Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({
                            name: 'damageLossesList'
                        });
                    } else {
                        this.disabled = false;
                        this.$notification.error(res.data.message, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                }).catch((error) => {
                    this.disabled = false;
                    this.isLoading = false;
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.commit('logout');
                            window.location.replace('login');
                        }
                        if (error.response.status === 422) {
                            this.$notification.error("Validation Error: " + error.response.data.message, {
                                timer: 5,
                                position: "bottomCenter"
                            });
                        }
                    }
                });
        },
        changeBook() {
            this.damageLossesData.type = this.getAllBooks[this.damageLossesData.book_id].type;
            this.damageLossesData.quantity = 0;
        },
    },
    mounted() {
        this.getMember();
        this.getBookList();
    }
};
